import { createFeatureSelector } from '@ngrx/store';
import { ModalState } from './modal.state';

export const MODAL_NAME = 'modal_claim-training';

export const modalState = createFeatureSelector<ModalState>(MODAL_NAME);
